import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE, DUR_SCREEN } from "@/lib/design";

// Fenêtre qui remonte du bas de l'écran (420ms), fond assombri derrière.
export const BottomSheet = ({ open, onClose, height = "70dvh", children, testId = "bottom-sheet", backdropOpacity = 0.72 }) => (
    <AnimatePresence>
        {open && (
            <>
                <motion.div
                    key="backdrop"
                    data-testid={`${testId}-backdrop`}
                    className="absolute inset-0 z-40"
                    style={{ backgroundColor: `rgba(0,0,0,${backdropOpacity})` }}
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    transition={{ duration: DUR_SCREEN, ease: EASE }}
                    onClick={onClose}
                />
                <motion.div
                    key="panel"
                    data-testid={testId}
                    className="absolute left-0 right-0 bottom-0 z-50 flex flex-col"
                    style={{
                        height, maxHeight: "96dvh", backgroundColor: "var(--surface)",
                        borderTop: "1px solid var(--border)",
                        borderRadius: "var(--radius-card) var(--radius-card) 0 0",
                        paddingBottom: "env(safe-area-inset-bottom, 0px)",
                    }}
                    initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
                    transition={{ duration: DUR_SCREEN, ease: EASE }}
                >
                    <div className="shrink-0 flex justify-center pt-3 pb-1">
                        <span style={{ width: 40, height: 4, borderRadius: 999, backgroundColor: "var(--border)" }} />
                    </div>
                    {children}
                </motion.div>
            </>
        )}
    </AnimatePresence>
);
